var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEHuquqshunos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_linear_1054_15142)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7514 14.4618C35.4385 14.5615 31.959 18.041 25 25C18.041 31.959 14.5615 35.4385 14.4618 39.7514C14.458 39.9171 14.458 40.0829 14.4618 40.2486C14.5615 44.5615 18.041 48.041 25 55C31.959 61.959 35.4385 65.4385 39.7514 65.5382C39.9171 65.542 40.0829 65.542 40.2486 65.5382C44.5615 65.4385 48.041 61.959 55 55C61.959 48.041 65.4385 44.5615 65.5382 40.2486C65.542 40.0829 65.542 39.9171 65.5382 39.7514C65.488 37.5789 64.5802 35.618 62.8022 33.3172L40.2239 55.8955L35.7463 51.4179L44.9254 42.2388L37.7612 35.0746L28.5821 44.2537L24.1045 39.7761L46.6828 17.1978C44.3821 15.4198 42.4211 14.512 40.2486 14.4618C40.0829 14.458 39.9171 14.458 39.7514 14.4618ZM51.4038 21.4321L42.2388 30.597L49.403 37.7612L58.5679 28.5962C57.502 27.502 56.3129 26.3129 55 25C53.6871 23.6871 52.498 22.498 51.4038 21.4321Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1054_15142",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#613EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3916C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEHuquqshunos);
export default __webpack_public_path__ + "static/media/e_huquqshunos.d93e359e4cd27c2162f91ede680c60e2.svg";
export { ForwardRef as ReactComponent };